// src/components/Sidebar.js
import React from 'react';
import { formatAgentName } from '../utils/formatNames';

const Sidebar = ({ agents, selectedAgent, onSelectAgent, onCreateAgent, onClose }) => {
  return (
    <div className="w-full bg-gray-900 text-white flex flex-col h-full shadow-lg">
      <div className="p-3 sm:p-4 border-b border-gray-800 flex items-center justify-between">
        <h2 className="text-sm sm:text-base lg:text-lg font-bold text-gray-100">My Agents</h2>
        {/* Close button for mobile */}
        {onClose && (
          <button
            onClick={onClose}
            className="lg:hidden p-2 text-gray-400 hover:text-gray-200 hover:bg-gray-800 rounded-md transition-colors"
            aria-label="Close sidebar"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
      
      <div className="flex-1 overflow-y-auto py-2">
        {agents && agents.length > 0 ? (
          <div className="space-y-1 px-2">
            {agents.map(agent => (
              <div
                key={agent.id}
                className={`p-2 sm:p-3 rounded-md cursor-pointer transition-all duration-200 ${
                  selectedAgent?.id === agent.id
                    ? 'bg-purple-700 text-white'
                    : 'hover:bg-gray-800 text-gray-300 hover:text-white'
                }`}
                onClick={() => {
                  onSelectAgent(agent.id);
                  // Close sidebar on mobile after selection
                  if (onClose && window.innerWidth < 1024) {
                    onClose();
                  }
                }}
              >
                <div className="flex items-center justify-between gap-1">
                  <span className="font-medium text-xs sm:text-sm truncate flex-1 min-w-0">{formatAgentName(agent.name)}</span>
                  {agent.active && (
                    <span className="flex items-center flex-shrink-0">
                      <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-400 rounded-full"></span>
                      <span className="text-[10px] sm:text-xs text-green-400 ml-1 hidden xs:inline">Active</span>
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-6 px-4">
            <p className="text-sm sm:text-base">No agents found</p>
          </div>
        )}
      </div>

      <div className="p-2 sm:p-3 border-t border-gray-800">
        <button
          onClick={() => {
            onCreateAgent();
            // Close sidebar on mobile after creating agent
            if (onClose && window.innerWidth < 1024) {
              onClose();
            }
          }}
          className="w-full py-2 sm:py-2.5 bg-purple-600 hover:bg-purple-700 rounded-md text-white font-medium transition-colors shadow-sm flex items-center justify-center text-xs sm:text-sm"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 sm:h-4 sm:w-4 mr-1.5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
          </svg>
          Create Agent
        </button>
      </div>
    </div>
  );
};

export default Sidebar;